"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "help-hotkeys" };
const _hoisted_2 = { class: "keys" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, null, [
        (0, vue_1.createElementVNode)("div", _hoisted_1, [
            (0, vue_1.createElementVNode)("div", _hoisted_2, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, [...(_cache[0] || (_cache[0] = [
                        (0, vue_1.createTextVNode)("Main Board", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, [...(_cache[1] || (_cache[1] = [
                        (0, vue_1.createTextVNode)("Players Overview Table", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, [...(_cache[2] || (_cache[2] = [
                        (0, vue_1.createTextVNode)("Cards in Hand", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, [...(_cache[3] || (_cache[3] = [
                        (0, vue_1.createTextVNode)("Colonies", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ]),
        _cache[4] || (_cache[4] = (0, vue_1.createElementVNode)("div", { class: "help-hotkeys-example" }, null, -1))
    ], 64));
}
